import { useState } from 'react';
import { ProductShelfItemProps } from './types';

export const useProductShelfItem = (props: ProductShelfItemProps) => {
  const { productData, onClickCard, onClickAdd, sectionType } = props;
  const [isBeingAdded, setIsBeingAdded] = useState(false);
  const handleClickLink = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClickCard?.(productData);
  };
  const handleClickAdd = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsBeingAdded(true);
    onClickAdd?.(productData, () => setIsBeingAdded(false), sectionType);
  };

  return { handleClickLink, handleClickAdd, isBeingAdded };
};
